import React from 'react';
import PropTypes from 'prop-types';

export class HelpIcon extends React.PureComponent {
  constructor(props) {
    super(props);
    this.element = React.createRef();
  }

  onClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    // eslint-disable-next-line no-undef
    PopupController.PopupJsClick(this.element.current);
  };

  render() {
    const { topic, ariaLabel, disabled } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
      <a
        ref={this.element}
        className="helpbutton"
        tabIndex="0"
        topic={topic.trim()}
        type="helppopup"
        onClick={this.onClick}
        // eslint-disable-next-line no-script-url
        href="#"
        aria-label={ariaLabel}
        disabled={disabled}
      />
    );
  }
}

HelpIcon.propTypes = {
  topic: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

HelpIcon.defaultProps = {
  ariaLabel: 'Learn more',
  disabled: false,
};
